module.exports = __webpack_public_path__ + "img/6_12.69109167.png";